import { ModalContainer, StyledModalWrapper } from './styles';
import React from 'react';
import { Container } from 'hocs/shared-styles';
import { Spinner } from '@hqo/react-components-library/dist/atoms/spinner';
import { defaultTheme } from '@hqo/react-components-library/dist/molecules/theme';
import { useIFrame } from 'hooks/payment-hook/use-iFrame.hook';
import { PaymentIFrameProps } from './paymentIFrame.interface';
import { useIframeInitData } from 'hooks/payment-hook/use-iFrame-init-data.hook';

export const PaymentIFrame = ({ reverseAnimation, bookingId, setBookingId }: PaymentIFrameProps) => {
  const {
    isContentLoading,
    handleIframeLoading,
    iFrameUrl,
    isCheckoutDesktop,
    isQuickCheckout,
    quickCheckout,
    isSwipeModalContent,
    isReceipt,
  } = useIFrame(bookingId, setBookingId);
  useIframeInitData();

  const buildContent = (): JSX.Element => (
    <ModalContainer
      quickCheckout={quickCheckout}
      isCheckoutDesktop={isCheckoutDesktop}
      isQuickCheckout={isQuickCheckout}
      isSwipeModalContent={isSwipeModalContent}
    >
      {isContentLoading ? (
        <Container isLoading isIframeLoading>
          <Spinner color={defaultTheme.colors.$greyLight} size="10em" />
        </Container>
      ) : null}
      <iframe
        frameBorder="0"
        src={iFrameUrl}
        title="Iframe SAML"
        id="payment-iframe"
        height="100%"
        width={isContentLoading ? '0%' : '100%'}
        data-testid="iframe_testid"
        sandbox="allow-scripts allow-same-origin allow-presentation allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation"
        onLoad={handleIframeLoading}
      />
    </ModalContainer>
  );

  return (
    <StyledModalWrapper
      reverseAnimation={reverseAnimation}
      quickCheckout={quickCheckout}
      isReceipt={isReceipt || !!bookingId}
      content={buildContent()}
      isCheckoutDesktop={isCheckoutDesktop}
      isQuickCheckout={isQuickCheckout}
    />
  );
};
